import { makeStyles } from '@material-ui/core';
import { backgroundColorLogin, corFM } from 'app/utils/coresUtil';

export const confirmarSenhaStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: backgroundColorLogin,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    padding: '1.6rem',
    [theme.breakpoints.up('sm')]: {
      padding: '3.2rem',
    },
  },
  card: {
    width: '100%',
    maxWidth: '38.4rem',
  },
  cardContent: {
    padding: '1.6rem',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      padding: '2.4rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: '3.2rem',
    },
  },
  'div.icone': {
    alignItems: 'center',
    textAlign: 'center',
  },
  icone: {
    margin: '3.2rem',
    fontSize: '9.6rem',
  },
  subtituloConfirmarEmail: {
    width: '100%',
    textAlign: 'center',
    marginBottom: '1.6rem',
    fontWeight: 600,
    color: corFM,
  },
  linkVoltar: {
    textAlign: 'center',
  },
}));
